<template>
  <MyJump v-if="jump" :to="jump" :msg="$t('page.order_refund.jump_msg')"/>
  <div v-else class="page-order-refund">
    <div class="title title-left">{{$t('page.order_refund.title')}}</div>
    <template v-if="mOrder.id>0">
      <Card :bordered="false" :shadow="false">
        <MyOrder :order="mOrder" detail/>
      </Card>

      <!-- 收件信息 -->
      <hr class="my-hr">
      <div class="title title-left">{{$t('order.receive_info')}}</div>
      <Card :bordered="false" :shadow="false">
        <div class="receive_info">
          <div>{{$t('order.label_receive_name')}}
            {{mOrder.receive_name}}
          </div>
          <div>{{$t('order.label_receive_tel')}}
            +{{mOrder.receive_tel}}
          </div>
          <div>{{$t('order.label_transport_way')}}
            <span v-if="mOrder.express">{{mOrder.express.name}}</span>
            <span v-else>{{$t('order.way_logistics')}}</span>
          </div>
          <div v-if="mOrder.delivery_no">
            <div>{{$t('order.label_delivery_no')}}{{mOrder.delivery_no}}</div>
          </div>
          <div v-if="mOrder.receive_area">{{$t('order.label_receive_addr')}}
            {{mOrder.receive_area|removePad}}{{mOrder.receive_address }}
          </div>
        </div>
      </Card>

      <!-- 退货信息 -->
      <hr class="my-hr">
      <div class="title title-left">{{$t('order.refund_info')}}</div>
      <Card :bordered="false" :shadow="false" class="bottom-padding">
        <div class="refund_info">
          <div>{{$t('order.label_refund_reason')}}
            <Select v-model="form.reason" style="width: auto;min-width: 50%;"
                    :placeholder="$t('page.order_refund.ph_select')">
              <Option label="不喜欢" value="不喜欢"/>
              <Option label="太丑" value="太丑"/>
              <Option label="换钱用" value="换钱用"/>
            </Select>
          </div>
          <div>{{$t('order.label_refund_user')}}
            <Input v-model="form.username" style="width: auto;min-width: 50%;"
                   maxlength="20" :placeholder="$t('page.order_refund.ph_input')"/>
          </div>
          <div>{{$t('order.label_refund_addr')}}
            <Input v-model="form.addr_info" style="width: auto;min-width: 50%;"
                   readonly @on-focus="onAddrEdit"
                   :placeholder="$t('page.order_refund.ph_input')"/>
          </div>
          <div>{{$t('order.label_refund_tel')}}
            <Input v-model="form.tel" style="width: auto;min-width: 50%;"
                   maxlength="20" :placeholder="$t('page.order_refund.ph_input')"/>
          </div>

          <div>{{$t('order.label_refund_account')}}
            <Input v-model="form.bank_user" style="width: auto;" maxlength="20"
                   :placeholder="$t('page.order_refund.ph_bank_user')"/>&nbsp;
            <Input v-model="form.bank_code" style="width: auto;" maxlength="20"
                   :placeholder="$t('page.order_refund.ph_bank_code')"/>&nbsp;
            <Input v-model="form.bank_name" style="width: auto;" maxlength="20"
                   :placeholder="$t('page.order_refund.ph_bank_name')"/>&nbsp;
            <Input v-model="form.bank_account" style="width: auto;min-width: 20em;" maxlength="20"
                   :placeholder="$t('page.order_refund.ph_bank_account')"/>
          </div>
        </div>
      </Card>

      <div style="height: 100px;"/>
      <div class="bottom-buttons">
        <Button class="btn btn-ok" long
                @click.stop="onRefund">{{$t('page.order_refund.btn_request')}}</Button>
        <br>
        <Button long class="btn"
                @click.stop="$router.go(-1)">{{$t('common.btn_back')}}</Button>
      </div>

      <!-- 地址编辑 -->
      <Modal v-model="mAddrEditShow" footer-hide
             :title="$t('page.order_refund.title_addr')">
        <AddrEdit :addr="form.addr" :ok-mode="true" @on-ok="onAddrOK"/>
      </Modal>
    </template>
    <p v-else-if="!loading"
       class="no-content-tip">{{$t('order.no_order')}}</p>
  </div>
</template>
<script>
    import { httpGetParams, CancelToken } from '@/api/http';
    import AddrEdit from '@/components/AddrEdit';
    import MyOrder from '@/components/MyOrder';
    import MyJump from '@/components/MyJump';

    export default {
        components: {
            MyJump,
            MyOrder,
            AddrEdit
        },
        data () {
            return {
                jump: null,

                loading: false,
                mOrder: {
                    id: 0
                },
                mAddrEditShow: false,
                form: {
                    reason: '',
                    username: '',
                    addr: null,
                    addr_info: '',
                    tel: '',
                    bank_user: '',
                    bank_code: '',
                    bank_name: '',
                    bank_account: ''
                }
            }
        },
        filters: {
            removePad: function (str) {
                return str.replace(/\s+/g, '')
            }
        },
        methods: {
            getData (id) {
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                this.loading = true;
                this.$Spin.show();
                httpGetParams('/v1/mall/order/' + id, this.form, new CancelToken((c) => {
                    this.cancel = c
                })).then(res => {
                    this.mOrder = res;
                }).catch(() => {
                }).finally(() => {
                    this.loading = false;
                    this.$Spin.hide();
                    this.cancel = null;
                });
            },
            onAddrEdit () {
                let addr;
                if (this.form.addr) {
                    addr = { ...this.form.addr };
                } else {
                    addr = {
                        receive_name: '',
                        receive_tel: '',
                        area_info: '',
                        address: ''
                    };
                }
                addr.receive_name = this.form.username;
                addr.receive_tel = this.form.tel;
                this.form.addr = addr;
                this.mAddrEditShow = true;
            },
            onAddrOK (addr) {
                this.form.username = addr.receive_name;
                this.form.tel = addr.receive_tel;
                this.form.addr_info = addr.area_info.replace(/\s+/g, '') + addr.address;
                this.form.addr = addr;
                this.mAddrEditShow = false;
            },
            onRefund () {
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                this.jump = {
                    name: 'Home',
                    query: {
                        id: this.mOrder.id
                    }
                };
                /* this.loading = true
                this.$Spin.show();
                const nums = {};
                let ids = '';
                for (const i in this.mOrder.items) {
                    const item = this.mOrder.items[i];
                    if (ids) {
                        ids += ',';
                    }
                    ids += item.goods_id;
                    nums[item.id] = item.num;
                }
                httpGetParams('/v1/goods/search', {
                    ids
                }, new CancelToken((c) => {
                    this.cancel = c
                })).then(res => {
                    if (res.length === 0) {
                        this.loading = false
                        this.$Spin.hide();
                        this.cancel = null;
                        this.$Message.error(this.$t('goods.tip_no_exist'));
                        return;
                    }
                    const order = this.$router.face.order();
                    for (const i in res) {
                        const item = res[i];
                        order.append(item, nums[item.id]);
                    }
                    order.go();
                }).catch(() => {
                }).finally(() => {
                    this.loading = false;
                    this.$Spin.hide();
                    this.cancel = null;
                }); */
            }
        },
        created () {
            const order = this.$route.params.order;
            if (!order) {
                this.$Message.error(this.$t('common.err_param'));
                this.$router.back();
                return;
            }
            this.mOrder = order;
            this.getData(order.id);
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
  .page-order-refund {
    .receive_info, .refund_info {
      &>div{
        line-height: 200%;
      }
    }
    .refund_info {
      .ivu-input {
        border-radius: 0;
        border-left: none;
        border-right: none;
        border-top: none;
        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }
    .bottom-padding{
      padding-bottom: 50px;
    }
    .order-time{
      &>div{
        display: flex;
        align-items: center;
        line-height: 120%;

        &>div:first-child{
          min-width: 100px;
        }
        margin-bottom: 10px;
      }
    }
  }
</style>
